module.exports = __webpack_public_path__ + "static/media/rotate-left.b631e834.svg";